// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"ProjectPage_Tabs__bH4e-"};